import {extend} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

for (const [rule, validation] of Object.entries(rules)) {
    // @ts-ignore
    extend(rule, {
        ...validation,
    });
}
